import React, { Component } from 'react';
import {connect} from 'react-redux';
import CookiesComponent from '../components/App/CookiesView';
import {DEFAULT_LANGUAGE} from '../constants';


class CookiesLayout extends Component {

  constructor(props) {
    super(props);
    this.applyCookies = this.applyCookies.bind(this);
    this.showSettingsCookies = this.showSettingsCookies.bind(this);
    this.state = {
      apply: false,
      settings: false
    };
  }

  componentDidMount() {
    if (localStorage.getItem("cookiesApply") === 'true') {
      this.setState({
        apply: true
      });
    }
    window.addEventListener('storage', (event) => {
      if (event.storageArea === localStorage && event.storageArea.getItem('cookiesApply')) {
        this.setState({
          apply: true
        });
      }
    }, false);
  }

  applyCookies() {
    localStorage.setItem("cookiesApply", 'true');
    this.setState({
      apply: true
    });
  }

  showSettingsCookies() {
    this.setState({
      settings: !this.state.settings
    });
  }

  render() {
    const {applyCookies, showSettingsCookies} = this;
    const {apply, settings} = this.state;
    const {language} = this.props;
    return (
      <div className='recap'>
        {!apply &&
          <CookiesComponent
            applyCookies={applyCookies}
            showSettingsCookies={showSettingsCookies}
            settings={settings}
            language={language || DEFAULT_LANGUAGE}
          />
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language.defaultLanguage,
  }
}

export default connect(mapStateToProps)(CookiesLayout);


// WEBPACK FOOTER //
// ./src/containers/Coockies.js